import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReduser from "./redusers/rootReduser";
const initialState = {};
const middleware = [thunk];
const store = createStore(
  rootReduser,
  initialState,
 applyMiddleware(...middleware)
);
export default store;
  